<template>
  <div>
    <div class="caption grey--text">{{ component.label }}</div>
    <v-chip class="black--text" label disabled> {{ selectedValue }} </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    component: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: undefined
    },
    diagnosis: {
      type: Object
    }
  },
  data() {
    return { selectedValue: this.value }
  },
  watch: {
    diagnosis: {
      handler() {
        const option = this.component.options.find(
          o => o.value === this.diagnosis.categoryId
        )

        this.selectedValue = option ? option.text : ''

        this.$emit('input', this.diagnosis.categoryId)
      },
      deep: true
    }
  }
}
</script>
